// Service de recherche globale pour l'autocomplete
class GlobalSearchService {
  constructor() {
    this.searchResults = [];
  }

  // Recherche dans tous les modules
  async searchAll(query, hooks) {
    if (!query || query.length < 2) {
      return [];
    }

    const results = [];
    const searchTerm = query.toLowerCase();

    try {
      // Recherche dans les clients
      if (hooks.clients?.length > 0) {
        const clientMatches = hooks.clients.filter(client =>
          client.name?.toLowerCase().includes(searchTerm) ||
          client.email?.toLowerCase().includes(searchTerm) ||
          client.phone?.includes(searchTerm)
        ).slice(0, 3); // Limiter à 3 résultats par module

        clientMatches.forEach(client => {
          results.push({
            id: client.id,
            title: client.name,
            subtitle: client.email,
            module: 'clients',
            type: 'Client',
            route: `/clients/${client.id}`,
            icon: '👤'
          });
        });
      }

      // Recherche dans les prestataires
      if (hooks.prestataires?.length > 0) {
        const prestataireMatches = hooks.prestataires.filter(prestataire =>
          prestataire.business_name?.toLowerCase().includes(searchTerm) ||
          prestataire.first_name?.toLowerCase().includes(searchTerm) ||
          prestataire.last_name?.toLowerCase().includes(searchTerm) ||
          prestataire.email?.toLowerCase().includes(searchTerm) ||
          prestataire.phone?.includes(searchTerm)
        ).slice(0, 3);

        prestataireMatches.forEach(prestataire => {
          const name = prestataire.business_name || `${prestataire.first_name} ${prestataire.last_name}`;
          results.push({
            id: prestataire.id,
            title: name,
            subtitle: prestataire.email,
            module: 'prestataires',
            type: 'Prestataire',
            route: `/prestataires/${prestataire.id}`,
            icon: '🏢'
          });
        });
      }

      // Recherche dans les missions
      if (hooks.missions?.length > 0) {
        const missionMatches = hooks.missions.filter(mission =>
          mission.id?.toString().includes(searchTerm) ||
          mission.client?.toLowerCase().includes(searchTerm) ||
          mission.prestataire?.toLowerCase().includes(searchTerm) ||
          mission.service_type?.toLowerCase().includes(searchTerm)
        ).slice(0, 3);

        missionMatches.forEach(mission => {
          results.push({
            id: mission.id,
            title: `Mission #${mission.id.toString().substring(0, 8)}`,
            subtitle: `${mission.client} → ${mission.prestataire}`,
            module: 'missions',
            type: 'Mission',
            route: `/missions/${mission.id}`,
            icon: '📋'
          });
        });
      }

      // Recherche dans les services
      if (hooks.services?.length > 0) {
        const serviceMatches = hooks.services.filter(service =>
          service.name?.toLowerCase().includes(searchTerm) ||
          service.description?.toLowerCase().includes(searchTerm)
        ).slice(0, 3);

        serviceMatches.forEach(service => {
          results.push({
            id: service.id,
            title: service.name,
            subtitle: service.description || 'Service',
            module: 'services',
            type: 'Service',
            route: `/services`,
            icon: '⚙️'
          });
        });
      }

      // Recherche dans les véhicules
      if (hooks.vehicules?.length > 0) {
        const vehiculeMatches = hooks.vehicules.filter(vehicule =>
          vehicule.brand?.toLowerCase().includes(searchTerm) ||
          vehicule.model?.toLowerCase().includes(searchTerm) ||
          vehicule.vehicle_type_name?.toLowerCase().includes(searchTerm) ||
          vehicule.license_plate?.toLowerCase().includes(searchTerm)
        ).slice(0, 3);

        vehiculeMatches.forEach(vehicule => {
          const name = vehicule.brand && vehicule.model 
            ? `${vehicule.brand} ${vehicule.model}`
            : vehicule.vehicle_type_name;
          results.push({
            id: vehicule.id,
            title: name,
            subtitle: vehicule.license_plate || 'Véhicule',
            module: 'vehicules',
            type: 'Véhicule',
            route: `/vehicules`,
            icon: '🚗'
          });
        });
      }

      // Recherche dans les signalements
      if (hooks.signalements?.length > 0) {
        const signalementMatches = hooks.signalements.filter(signalement =>
          signalement.id?.toString().includes(searchTerm) ||
          signalement.reported_by?.name?.toLowerCase().includes(searchTerm) ||
          signalement.reported_against?.name?.toLowerCase().includes(searchTerm) ||
          signalement.type?.toLowerCase().includes(searchTerm)
        ).slice(0, 3);

        signalementMatches.forEach(signalement => {
          results.push({
            id: signalement.id,
            title: `Signalement #${signalement.id}`,
            subtitle: signalement.type || 'Signalement',
            module: 'signalements',
            type: 'Signalement',
            route: `/signalements/${signalement.id}`,
            icon: '🚨'
          });
        });
      }

    } catch (error) {
      console.error('Erreur lors de la recherche globale:', error);
    }

    // Limiter le total des résultats à 10
    return results.slice(0, 10);
  }

  // Formater les résultats pour l'affichage
  formatResults(results) {
    if (results.length === 0) {
      return [{
        id: 'no-results',
        title: 'Aucun résultat trouvé',
        subtitle: 'Essayez avec des mots-clés différents',
        module: null,
        type: 'Info',
        route: null,
        icon: '❌'
      }];
    }

    return results;
  }

  // Grouper les résultats par module
  groupResultsByModule(results) {
    const grouped = {};
    results.forEach(result => {
      if (!grouped[result.module]) {
        grouped[result.module] = [];
      }
      grouped[result.module].push(result);
    });
    return grouped;
  }
}

export const globalSearchService = new GlobalSearchService();
export default globalSearchService;